module.exports = __webpack_public_path__ + "kz.svg?765abf25f0c5a3107513c0d71b66ea98";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/kz.svg
// module id = 1458
// module chunks = 0